export default "__VITE_ASSET__eb512293__"